export default "__VITE_ASSET__CRPS6mhl__"